module.exports = __webpack_public_path__ + "static/media/Cross-Small.6b318245.svg";